<template>
  <div class="streaming-text">
    <span v-for="(segment, i) in segments" :key="segment.id" :class="{ fade: segment.fade }">{{ segment.text }}</span>
  </div>
</template>

<script>
let id = 0;

export default {
  name: "StreamingFadeText",

  props: {
    message: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      segments: [],
      prevMessage: null,
    };
  },

  watch: {
    message: {
      immediate: true,
      handler(newMessage) {
        if (this.prevMessage === null) {
          if (newMessage) {
            this.segments.push({
              id: id++,
              text: newMessage,
              fade: false,
            });
          }
          this.prevMessage = newMessage;
          return;
        }

        if (newMessage.startsWith(this.prevMessage)) {
          const delta = newMessage.slice(this.prevMessage.length);
          if (!delta) return;

          this.segments.push({
            id: id++,
            text: delta,
            fade: true,
          });

          this.prevMessage = newMessage;
          return;
        }

        this.segments = [
          {
            id: id++,
            text: newMessage,
            fade: false,
          },
        ];
        this.prevMessage = newMessage;
      },
    },
  },
};
</script>

<style scoped>
.fade {
  animation: fadeIn 0.2s ease forwards;
  opacity: 0;
  filter: blur(5px);
}

@keyframes fadeIn {
  to {
    opacity: 1;
    filter: blur(0px);
  }
}
</style>
